export default __webpack_public_path__ + "static/media/filter_calendar_blue.352a6beb.svg";